var utils = require('lib/utils');

import ProgressService from 'services/progress-service';
import ActionPlanItemResponsesService from 'services/action-plan-item-responses-service';

var localSync = {
  read: function(method, model, options){
    var deferred = $.Deferred();
    if (typeof model.fileName === 'function') {
      model.fileName = model.fileName();
    }
    var localData = utils.tryRequire('/local-data/' + model.fileName);
    options.success(localData);
    if (options.parse){
      model.parse(localData, options);
    }
    return deferred.resolve();
  }
};

var customLocalSyncs = {
  ActivityProgressesCollection: {
    read: function (method, model, options) {
      var d = $.Deferred();
      var progresses = ProgressService.getLocalActivityProgresses();
      options.success(progresses);
      return d.resolve();
    }
  },
  Poll: {
    read: localSync.read,
    create: function(method, model, options) {
      var d = $.Deferred();
      var totals = [ ];
      model.get('answers').forEach((a) => {
        totals.push({ id: a.id, count: Math.floor(Math.random() * (500 - 1) + 1 )});
      });
      model.set('totals', totals);
      options.success({totals: totals});
      return d.resolve({totals:totals});
    }
  },
  Module: {
    read: Backbone.localSync
  },
  ModulesCollection: {
    read: Backbone.localSync
  },
  ActionPlanItemResponsesCollection: {
    read: function (method, model, options) {
      var d = $.Deferred();
      var actionPlanItemResponses = ActionPlanItemResponsesService.readLocal();
      options.success(actionPlanItemResponses);
      return d.resolve();
    }
  },
  ActionPlanItemResponse: {
    create: function(method, model, options) {
      var d = $.Deferred();
      var actionPlanItemResponses = ActionPlanItemResponsesService.readLocal();
      var savedId = Math.floor(Math.random() * (1000 - 1) + 1);
      model.set('id', savedId);
      actionPlanItemResponses.push(model.attributes);
      ActionPlanItemResponsesService.writeLocal(actionPlanItemResponses);
      return d.resolve({ id: savedId });
    },
    update: function(method, model, options) {
      var actionPlanItemResponses = ActionPlanItemResponsesService.readLocal();
      var responseIndex = _.findIndex(actionPlanItemResponses, (r) => { return r.id === model.get('id'); });
      actionPlanItemResponses[responseIndex] = model.attributes;
      ActionPlanItemResponsesService.writeLocal(actionPlanItemResponses);
      return $.Deferred().resolve();
    }
  }
};

var SyncService = {
  initialize: function(){

    var self = this;
    var overrideSync = function(model, name){
      if (customLocalSyncs[name] && model.prototype) {
        model.prototype.syncMethods = customLocalSyncs[name];
        model.prototype.localStorage = new Backbone.LocalStorage(name);
        model.prototype.sync = self.sync;
      } else if (model.prototype) {
        model.prototype.syncMethods = localSync;
        model.prototype.localStorage = new Backbone.LocalStorage(name);
        model.prototype.sync = self.sync;
      } else {
        _.each(model, overrideSync);
      }
    };

    _.each(EF.Models, overrideSync);
    _.each(EF.Collections, overrideSync);

  },
  sync: function(method, model, options) {
    if (this.syncMethods[method]){
      return this.syncMethods[method](method, model, options);
    } else {
      return Backbone.sync(method, model, options);
    }
  }
};

module.exports = SyncService;
